import { environment } from '@bvl-admin/environments/environment';

export class RoleEndpoint {
  public static rolesList = `${environment.LOAD_BALANCER}/role/permission/list`;
  public static rolesListPermissionsDetail = `${environment.LOAD_BALANCER}/role/permission/list/detail`;
  public static saveRole = `${environment.LOAD_BALANCER}/role/save`;
  public static updateRole = `${environment.LOAD_BALANCER}/role/update`;
  public static deleteRole = `${environment.LOAD_BALANCER}/role/permission/delete`;
}
